const PROCESS_STEPS = [
  {
    id: 1,
    title: 'Initial Contact',
    text: 'You reach out for a quick chat. You share your vision/idea, we answer your questions, and we schedule a convenient time to view your property.',
    accent: 'gold',
  },
  {
    id: 2,
    title: 'Free Consultation',
    text: 'We visit your property anywhere in South East London, assess the space and talk through your goals — no cost, no obligation.',
    accent: 'green',
  },
  {
    id: 3,
    title: 'Detailed Quote',
    text: 'You receive a clear, itemized written quote — materials, timeline, costs — all explained in plain English before you commit to anything.',
    accent: 'green',
  },
  {
    id: 4,
    title: 'Expert Installation',
    text: 'Our skilled team arrives on time, works cleanly and delivers exceptional craftsmanship — keeping you updated throughout.',
    accent: 'green',
  },
  {
    id: 5,
    title: 'Final Walkthrough',
    text: "We walk the finished job with you and check every detail. Only when you're fully satisfied do we consider it done.",
    accent: 'green',
  },
];

const Process = () => {
  return (
    <section className="process" id="process" aria-label="How it works">
      <div className="container">
        <div className="section-header">
          <p className="section-eyebrow">How It Works</p>
          <h2 className="section-title">Our Simple Process</h2>
          <div className="section-rule" aria-hidden="true"></div>
        </div>

        <ol className="process__steps">
          {PROCESS_STEPS.map((step) => (
            <li key={step.id} className="process__step">
              <div
                className={`process__step-num process__step-num--${step.accent}`}
                aria-hidden="true"
              >
                {step.id}
              </div>
              <p className="process__step-title">{step.title}</p>
              <p className="process__step-text">{step.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Process;
